var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('base-rounded-button',{attrs:{"color":"third","icon":"mdi-layers","shadow":""},on:{"click":function($event){_vm.isLegendVisible = true}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }